// extracted by mini-css-extract-plugin
export default {"root":"nT7eR","left":"_3_rnL","left-side-item-wrapper":"_3NPO1","leftSideItemWrapper":"_3NPO1","right":"wzoeL","right-side-item-wrapper":"Kn4l5","rightSideItemWrapper":"Kn4l5"};